import React, { useState } from 'react';
import { FaCopy, FaCheck } from 'react-icons/fa6';
import * as copyController from '../controllers/copyController';
import { useAnalytics } from '../../../../shared/hooks/useAnalytics';
import { EVENTS } from '../../../../shared/services/analyticsEvents';
import { useAppContext } from '../../../../shared/context/AppContext';
import './PromptDetails.css';
import './FreeTextContent.css';

const FreeTextContent = ({ promptText, promptId = null, promptTitle = null }) => {
  const [copied, setCopied] = useState(false);
  const { trackEvent } = useAnalytics();
  const { organization } = useAppContext();

  const handleCopy = async () => {
    const orgId = organization?.id || organization?.orgId || null;
    const success = await copyController.copyPrompt(promptText, promptId, orgId);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      // Track copy event if promptId is available
      if (promptId) {
        trackEvent(EVENTS.PROMPT_COPIED, {
          promptId,
          promptTitle: promptTitle || null,
          source: 'prompt_details',
        });
      }
    }
  };

  return (
    <div className="prompt-content-section">
      <div className="prompt-text-container">
        <div className="prompt-text-header">
          <h2 className="prompt-text-title">Prompt text</h2>
          <button
            className={`copy-prompt-button-small ${copied ? 'copied' : ''}`}
            data-tutorial-target="copy-button"
            onClick={handleCopy}
            aria-label={copied ? 'Copied!' : 'Copy'}
          >
            {copied ? (
              <>
                <FaCheck className="copy-icon" />
                <span className="copy-button-text">Copied!</span>
              </>
            ) : (
              <FaCopy className="copy-icon" />
            )}
          </button>
        </div>
        <div className="prompt-text-body">
          <div className="prompt-text free-text-content">
            {promptText || 'No prompt text available.'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeTextContent;
